export const ACTIVE_CORRIDORS_TABLE_HEADINGS = [
  'Corridor ID',
  'Source Currency',
  'Destination Currency',
  'Type',
  'Corridor Fees',
];

export const ERROR_FETCHING_ACTIVE_CORRIDORS = 'Error fetching active corridors.';
